import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import "./i18n";
import Home from "./component/page/home";
import Login from "./component/page/login";
import TeamInvite from "./component/page/teamInvite";
import NotFound from "./component/page/NotFound";
import SongPlatformsProvider from "./component/library/SongPlatformsProvider";
import DiscussionQuestionsProvider from "./component/service/DiscussionQuestionsProvider";
import PageTransition from "./component/navigation/PageTransition";
import Test from "./component/page/test";
import Library from "./component/page/library";
import PlaylistDetail from "./component/page/playlist";
import ServiceDetail from "./component/page/service";
import { SERVICE_DETAIL_ROUTE } from "./routes";

const container = document.getElementById("app");
if (!container) throw new Error("Missing #app container");

createRoot(container).render(
  <BrowserRouter>
    {/* Sheets presented from anywhere, standing in for the app's Navigator. */}
    <SongPlatformsProvider>
      <DiscussionQuestionsProvider>
        <PageTransition>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* Universal link targets, claimed in scripts/build-aasa.mjs */}
            <Route path="/app/login/:code" element={<Login />} />
            <Route path="/app/church/:churchId/team/:teamId" element={<TeamInvite />} />
            {/* Neither is linked from the app. /test previews a whole Launchpad;
                /library shows the components in isolation. */}
            <Route path="/test" element={<Test />} />
            <Route path="/library" element={<Library />} />
            <Route path="/playlist/:playlistId" element={<PlaylistDetail />} />
            <Route path={SERVICE_DETAIL_ROUTE} element={<ServiceDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageTransition>
      </DiscussionQuestionsProvider>
    </SongPlatformsProvider>
  </BrowserRouter>
);
